// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3588u","title":"styles-module--title--3Z7zA","content":"styles-module--content--3Y2g_"};